import { api } from './client';

export const adminApi = {
    // Dashboard
    summary: () => api.get('/api/v1/admin/dashboard/summary'),

    // Employees
    listEmployees: (params = {}) => {
        const q = new URLSearchParams();
        if (params.page) q.set('page', params.page);
        if (params.role) q.set('role', params.role);
        if (params.department) q.set('department', params.department);
        if (params.active !== undefined) q.set('active', params.active);
        if (params.search) q.set('search', params.search);
        const qs = q.toString();
        return api.get(`/api/v1/admin/employees${qs ? '?' + qs : ''}`);
    },
    getEmployee: (id) => api.get(`/api/v1/admin/employees/${id}`),
    createEmployee: (body) => api.post('/api/v1/admin/employees', body),
    updateEmployee: (id, body) => api.patch(`/api/v1/admin/employees/${id}`, body),
    resetPassword: (id) => api.post(`/api/v1/admin/employees/${id}/reset-password`),
    forceLogout: (id) => api.post(`/api/v1/admin/employees/${id}/force-logout`),
    unlock: (id) => api.post(`/api/v1/admin/employees/${id}/unlock`),
    updateShift: (id, body) => api.put(`/api/v1/admin/employees/${id}/shift`, body),
    getEmployeeAttendance: (id, { start, end }) => {
        const q = new URLSearchParams({ start, end });
        return api.get(`/api/v1/admin/employees/${id}/attendance?${q.toString()}`);
    },
    getEmployeeScreenshots: (id, { start, end }) => {
        const q = new URLSearchParams({ start, end });
        return api.get(`/api/v1/admin/employees/${id}/screenshots?${q.toString()}`);
    },
    fetchScreenshotBlob: (id) => api.getBlob(`/api/v1/screenshots/${id}`),

    // Holidays
    listHolidays: (year) => {
        const q = new URLSearchParams();
        if (year !== undefined) q.set('year', String(year));
        const qs = q.toString();
        return api.get(`/api/v1/admin/holidays${qs ? '?' + qs : ''}`);
    },
    createHoliday: (body) => api.post('/api/v1/admin/holidays', body),
    updateHoliday: (id, body) => api.patch(`/api/v1/admin/holidays/${id}`, body),
    deleteHoliday: (id) => api.del(`/api/v1/admin/holidays/${id}`),

    // Departments + manager grants
    listDepartments: () => api.get('/api/v1/admin/departments'),
    setManagerDepartments: (id, departments) =>
        api.put(`/api/v1/admin/employees/${id}/manager-departments`, { departments }),

    // Cron status
    cronStatus: () => api.get('/api/v1/admin/cron/status'),
};
